import { render, staticRenderFns } from "./ExpressDialog.vue?vue&type=template&id=818a1b62&"
import script from "./ExpressDialog.vue?vue&type=script&lang=js&"
export * from "./ExpressDialog.vue?vue&type=script&lang=js&"
import style0 from "./ExpressDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports